
import CxP from "@/views/CxP/CxP.vue";
import PaymentsCxp from "@/views/CxP/Payments.vue";
import TransactionsCxP from "@/views/CxP/Transactions.vue"
import ViewPayments from "@/views/CxP/ViewPayments.vue"
import ViewTransactionsCxP from "@/views/CxP/ViewTransactionsCxP.vue"
import GenerateCheck from "@/views/CxP/GenerateCheck.vue"
import DirectPayment from "@/views/CxP/DirectPayment.vue"
import ViewDirectPaymentCxp from "@/views/CxC/ViewDirectPayment.vue";
import BenefitInvoices from "@/views/CxP/BenefitInvoices.vue"
import BenefitGroupDetail from "@/views/CxP/BenefitGroupDetail.vue"
import BenefitProcess from "@/views/CxP/BenefitProcess.vue"
const cxpRoute=  {
    path: "/cxp",
    name: "cxp",
    component: CxP,
    meta: {
      libre: true
    },
    children: [
      {
        path: "transactions_cxp",
        name: "TransactionsCxP",
        component: TransactionsCxP,
        meta: {
          code: "CXP-01" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "payments_cxp",
        name: "PaymentsCxp",
        component: PaymentsCxp,
        meta: {
          code: "CXP-02" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "direct_payments_cxp",
        name: "DirectPaymentsCxp",
        component: DirectPayment,
        meta: {
          code: "CXP-02" // Cambiado de IVENTORY: true a un código específico
        },
      },
            {
              path: "view_pre_payment_cxp/:id?",
       
              name: "ViewDirectPaymentCxp",
              component: ViewDirectPaymentCxp,
              meta: {
                code: "CXP-02" // Cambiado de IVENTORY: true a un código específico
              },
            },
      {
        path: "generate_sequence_check ",
        name: "GenerateCheck",
        component: GenerateCheck,
        meta: {
          code: "CXP-03" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "view_payments/:id?",
        name: "ViewPaymentsCxP",
        component: ViewPayments,
        meta: {
          code: "CXP-04" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "view_transactions_cxp/:id?",
        name: "ViewTransactionsCxP",
        component: ViewTransactionsCxP,
        meta: {
          code: "CXP-05" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "benefit_invoices",
        name: "BenefitInvoices",
        component: BenefitInvoices,
        meta: {
          code: "SHOP-16"
        },
      },
      {
        path: "benefit_invoices/:benefit_group_id",
        name: "BenefitGroupDetail",
        component: BenefitGroupDetail,
        meta: {
          code: "SHOP-16"
        },
      },
      {
        path: "benefit_invoices/:benefit_group_id/process",
        name: "BenefitProcess",
        component: BenefitProcess,
        meta: {
          code: "SHOP-16"
        },
      },
      // {
      //   path: "view_transactions/:id?",
      //   name: "ViewTransactions",
      //   component: ViewTransactions,
      //   meta: {
      //     SHOP: true,
      //   },
      // },
    ],
  }


export default cxpRoute
